import { Route, Switch } from "react-router";
import { routeEdit, routeRoot } from "../../settings/routerConfig";

import { Fragment } from "react";
import ImgBanner from "../../images/bannerProv.jpg";
import ProveedorEdit from "./ProveedorEdit";
import ProveedoresStepper from "./ProveedoresStepper";
import ProveedoresTitle from "./ProveedoresTitle";
import { Typography } from "@material-ui/core";
import { useProveedoresProspectos } from "../../context/ProveedoresProspectosContext";

const ProveedoresPage = () => {
    const { entSolicitudDetalleForEdit } = useProveedoresProspectos();

    return (
        <Switch>
            <Route exact path={routeRoot}>
                <div className="back-container">
                    <div className="back-content">
                        <nav className="cover container">
                            <img src={ImgBanner} alt="bannerprov" />
                        </nav>
                        <ProveedoresTitle hideDivider>
                            {!entSolicitudDetalleForEdit ? (
                                "INFORMACIÓN DE PROVEEDOR PROSPECTO"
                            ) : (
                                <Fragment>
                                    EDICIÓN DE SOLICITUD DE PROVEEDOR
                                    <br />
                                    <Typography variant="h5">Folio: {entSolicitudDetalleForEdit.sFolioProspecto}</Typography>
                                </Fragment>
                            )}
                        </ProveedoresTitle>
                        <ProveedoresStepper />
                    </div>
                    <footer className="footer">
                        <div className="container footer-main">
                            <span className="footer-description">Bepensa &copy; {new Date().getFullYear()}</span>
                            <a href=".">Aviso de privacidad</a>
                            <span className="footer-slash">/</span>
                            <a href=".">Aviso Fiscal</a>
                        </div>
                    </footer>
                </div>
            </Route>
            <Route exact path={routeEdit}>
                <ProveedorEdit />
            </Route>
        </Switch>
    );
};

export default ProveedoresPage;
